import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import { Modal, Button, Input } from '@gpstrackit/gtc-react-controls';

import { NotificationManager } from 'Components/Notifications';
// Material UI
import { Typography } from '@mui/material';

import {
    routesModalCloneRoute,
    openModalCreateEditRouteModalMain,
    routesSearchRoutes
} from 'Redux/actions';

import './style.scss';

import { reset } from './redux/slice'
import { reset as resetOpenModalEditRouteMain } from '../createEditRouteModalMain/redux/slice'


const ModalCloneRoute = () => {
  const dispatch = useDispatch();
  
  const { messages, locale } = useIntl();

  const [name, setName] = useState('')

  
  const open = useSelector(state => state.routesTemplateModalCloneRoute.open);
  const loading = useSelector(state => state.routesTemplateModalCloneRoute.loading);
  const routeId = useSelector(state => state.routesTemplateModalCloneRoute.routeId);
  const route = useSelector(state => state.routesTemplateModalCloneRoute.route);
  const isTemplate = useSelector(state => state.routesTemplateModalCloneRoute.isTemplate);
  const cloneRouteResponse = useSelector(state => state.routesTemplateModalCloneRoute.cloneRouteResponse);
  const erorrRoutes = useSelector(state => state.routesTemplateModalCloneRoute.erorrRoutes);
  const filters = useSelector(state => state.routesManagedRedux.filters);

  useEffect(() => {
    if (open && (cloneRouteResponse)) {
      if (erorrRoutes) {
        NotificationManager.error(
          messages['routes_error'],
          messages['fsmRoute_modal_editCreate_error_name'],
          3000,
          null,
          null,
          'warning',
        );
        return
      } else {
        NotificationManager.success(
          messages['routes_templates_modal_cloneRoute_sucess'],
          messages['success'],
          3000,
          null,
          null,
          'success',
        );
      }

      //open modal in new route
      if(route?.id > 0){
        //search routes
        dispatch(openModalCreateEditRouteModalMain({open: true, routeId: route.id, isTemplate: isTemplate}));
        dispatch(routesSearchRoutes({...filters}));

        //reset addRoutesTracker Vars entered
        dispatch(resetOpenModalEditRouteMain({
          isTemplate: 0,
          driverId : 0,
          templateRouteId: 0,
          scheduledAt: null
        }))

      }       
      //close the modal
      dispatch(reset())
    }
    
  }, [cloneRouteResponse, open]);


  const handleClose = useCallback(() => {
    dispatch(reset())
  });

  return (
    <Modal
      open={open || false}
      handleClose={handleClose}
      loading={loading}
      title={messages['routes_templates_modal_cloneRoute_title']}
      position="right"
      size="small"
      closeButton={false}
      footer={
        <div>
          <Button 
          variant="secondary" 
          style={{ marginRight: 8 }} 
          onClick={() => { handleClose()}}
          >
            {messages['cancel']}
          </Button>
          <Button 
            variant="primary"
            isDisabled={loading || (!name || name && name.trim().length < 3)} 
            onClick={(e) => { 
              e.preventDefault();    
                dispatch((routesModalCloneRoute({ ...route, title: name.trim(), isTemplate: isTemplate })));
            }}
            >
              {messages['routes_templates_modal_cloneRoute_title']}
            </Button>
        </div>
      }
    >
      <div>
        <div style={{ padding: 24 }}>
          <Typography variant="subtitle2" style={{ color: '#2d2d2d', fontWeight: 400}}>
            {messages['routes_templates_modal_cloneRoute_label']}
          </Typography>
        </div>
        <div style={{ padding: "0px 30px"}}>
            <div>
                <label className="input-normal-label">{messages['routes_name']}</label>
            </div>
            <div>
                <Input
                    loading={loading}
                    id="name"
                    type={"text"}
                    placeholder={messages['routes_name']}
                    value={name}
                    onChange={(value) => { 
                        setName(value)
                    }}
                    required
                    requiredMessage={messages['required_field']}
                    minLengthMessage={messages['route_minLengthMessage']}
                    maxLengthMessage={messages['route_maxLengthMessage']}
                    minLength={4}
                    maxLength={50}
                />
            </div>
            {
                erorrRoutes 
                &&
                <div style={{ marginTop: 10}}>
                    <label className="input-normal-label clone-route-label-error">{messages['fsmRoute_modal_editCreate_error_name']}</label>
                </div>
            }
        </div>
        
        
      </div>
    </Modal>
  );
}

export default ModalCloneRoute;